export default {
    // nodeapipath:"http://localhost:8000"


    nodeapipath:'http://142.93.221.247:8000'
}